import React from 'react';

import styles from './TaskListHeader.module.scss';

const HEADER_PADDING = 10;

type TaskListHeaderDefaultProps = {
	headerHeight: number;
}

const TaskListHeaderDefault: React.FC<TaskListHeaderDefaultProps> = ({
	headerHeight,
}) => {
	const headerHeightValue = headerHeight - (HEADER_PADDING * 2);

	return (
		<div
			className={styles.ganttTable}
			style={{
				padding: `${HEADER_PADDING}px`,
			}}
		>
			<div
				className={styles.ganttTable_Header}
				style={{
					height: headerHeightValue,
				}}
			>
				<div
					className={styles.ganttTable_HeaderItem}
					style={{
						minWidth: '20px',
						paddingRight: '30px',
					}}
				/>
				<div
					className={styles.ganttTable_HeaderItem}
					style={{
						minWidth: '150px',
						paddingRight: '30px',
					}}
				>
					MILESTONE/TASK
				</div>
				<div
					className={styles.ganttTable_HeaderItem}
					style={{
						minWidth: '200px',
						paddingRight: '30px',
					}}
				>
					ASSIGNEES
				</div>
				<div
					className={styles.ganttTable_HeaderItem}
					style={{
						minWidth: '120px',
						paddingRight: '30px',
					}}
				>
					START DATE
				</div>
				<div
					className={styles.ganttTable_HeaderItem}
					style={{
						minWidth: '120px',
					}}
				>
					END DATE
				</div>
			</div>
		</div>
	);
};

export default TaskListHeaderDefault;
